import domReady from '@roots/sage/client/dom-ready';

/**
 * Dom ready
 */
domReady(() => {
  // Only show on homepage
  if (window.location.pathname !== '/') {
    return;
  }

  const popup = document.getElementById('custom-popup');
  const closeBtn = popup.querySelector('.popup-close');
  const dismissBtn = popup.querySelector('.popup-dismiss');

  // Always show popup
  popup.style.display = 'flex';

  function closePopup() {
    popup.style.display = 'none';
  }

  closeBtn.addEventListener('click', closePopup);
  dismissBtn.addEventListener('click', closePopup);
});
